// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es/promise'
import 'core-js/es/string'
import 'core-js/es/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueMoment from 'vue-moment'
import VueTable from 'vuetable-2'
const initToken = localStorage.getItem('token') || ''

import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry)

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(VueMoment)
Vue.use(VueTable)

if (initToken) {
  axios.defaults.headers.common.Authorization = `Bearer ${initToken}`
}

Vue.prototype.$http = axios
Vue.prototype.$api_url = process.env.VUE_APP_API_URL

export const Bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
